import { mapGetters } from "vuex"

const handles_uploads = {
    methods: {
        upload_file (name, file) {
            this.$set(this.uploaded, name, 0)
            this.$set(this.uploading, name, 1)

            const upload_progression = event => {
                this.$set(this.uploaded, name, parseInt(Math.round((event.loaded * 100) / event.total)))
            }
            const upload_data = this.upload_data(name, "upload")

            return this.$store.dispatch("FILE_ACTION", {
                ...upload_data,
                name,
                action: this.attach_action,
                file: file,
                progress: upload_progression
            }).then(response => {
                this.upload_attached(name, response)
                this.$emit("uploaded", response.data)
            }).catch(error => {
                this.upload_attach_error(name, error)
            }).then(() => {
                this.$set(this.uploading, name, 0)
            })
        },
        upload_file_list (name, file_list) {
            const files = []
            Array.from(file_list).forEach(file => {
                if(this.upload_accepts(name, file.name)) files.push(file)
            })

            if(!files.length) this.$error("Invalid file type")
            else return this.upload_file(name, files[0])
        },
        confirm_clear_file (name) {
            this.confirming_clear_file = name
            this.$confirm({
                type: "error",
                title: "Remove uploaded file",
                message: "Do you really want to delete the uploaded file? Make sure you have a copy if you think you'll need it again some day.",
                cancel: "Keep It",
                ok: "Remove It",
                then: (confirmed) => {
                    if(confirmed) this.clear_file()
                }
            })
        },
        clear_file () {
            this.clearing_file = true
            this.$store.dispatch("FILE_ACTION", {
                ...this.upload_data(this.confirming_clear_file, "clear"),
                name: this.confirming_clear_file,
                action: this.detach_action
            }).then(response => {
                this.upload_detached(this.confirming_clear_file, response)
            }).catch(error => {
                this.upload_detach_error(this.confirming_clear_file, error)
            }).then(() => {
                this.clearing_file = false
            })
        },
        upload_accepts (name, filename = null) {
            if(filename) return true
            return ""
        },
        upload_data (mode) {
            return {}
        },
        upload_attach_error (name, error) {
            console.error("upload_attach_error", name, error)
        },
        upload_attached (name, record) {
            // console.log("upload_attached", name, record)
        },
        upload_detach_error (name, error) {
            console.error("upload_detach_error", name, error)
        },
        upload_detached (name, response) {
            // console.log("upload_detached", name, response)
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_attachment_records () {
            return this.entity_records("attachment")
        }
    },
    data () {
        return {
            attach_action: "attach",
            detach_action: "detach",
            uploaded: {},
            uploading: {},
            confirming_clear_file: null,
            clearing_file: false
        }
    }
}

export default handles_uploads
